import GridTile from "../../grid/GridTile";

export default class ScoreTile {
    constructor() {
        /**
         * @type {number}
         */
        this.score = 0;
        /**
         * @type {GridTile}
         */
        this.tile = null;
    }

    reset() {
        this.score = 0;
        this.tile = null;
    }

    /**
     * @param {number} score 
     * @param {GridTile} tile 
     */
    set(score, tile) {
        this.score = score;
        this.tile = tile;
    }

    /**
     * @param {ScoreTile} scoreTile 
     */
    copy(scoreTile) {
        this.score = scoreTile.score;
        this.tile = scoreTile.tile;
    }
}